import classNames from 'classnames';
import React, { useEffect, useMemo, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { Carousel as BsCarousel } from 'react-bootstrap';

const bsProps = {
  bsClass: 'carousel',
};

// custom the Carousel component from react-bootstrap to put the
// controls (left/right arrows) and indicators (dots) within a same
// parent div, to make it easy to align them, like this: "< .... >"
//
// !!NOTE!!
// The implementation is highly coupled with the internal implementation
// of react-bootstrap Carousel, it calls the internal methods of BsCarousel
// by using reference
export const CustomCarousel = (props) => {
  const carouselRef = useRef(null);
  const {
    controls, // ignore this prop
    indicators, // ignore this prop
    activeIndex,
    children,
    InjectedControls,
    carouselWrapperClassName,
    ...rest
  } = props;

  const [carouselInstance, setCarouselInstance] = useState(null);

  useEffect(() => {
    if (!carouselInstance) {
      setCarouselInstance(carouselRef.current);
    }
  }, [carouselInstance]);

  const [leftArrowControl, rightArrowControl] = useMemo(() => {
    if (carouselInstance) {
      return carouselInstance.renderControls({ ...props, bsProps });
    }
    return [undefined, undefined];
  }, [carouselInstance, props]);

  return (
    <div className={classNames('carousel-wrapper', carouselWrapperClassName)}>
      <BsCarousel
        ref={carouselRef}
        activeIndex={activeIndex}
        controls={false} // disable rendering contorls and indicators
        indicators={false}
        {...rest}
      >
        {children}
      </BsCarousel>
      <div className="custom-carousel-controls-and-indicators">
        {/* render custom controls and indicators in the same parent div */}
        {leftArrowControl}
        {carouselInstance ? carouselInstance.renderIndicators(children, activeIndex, bsProps) : null}
        {rightArrowControl}
        {
          InjectedControls ? <> {InjectedControls} </> : null
        }
      </div>
    </div>
  );
};

CustomCarousel.propTypes = {
  activeIndex: PropTypes.number.isRequired,
  controls: PropTypes.bool,
  indicators: PropTypes.bool,
  children: PropTypes.node,
  InjectedControls: PropTypes.element,
  carouselWrapperClassName: PropTypes.string,
};

CustomCarousel.defaultProps = {
  // use the default props from react-bootstrap Carousel, including default icons
  ...BsCarousel.defaultProps,
  //
  controls: false,
  indicators: false,
  children: null,
  InjectedControls: null,
  carouselWrapperClassName: null,
};

CustomCarousel.Caption = BsCarousel.Caption;
CustomCarousel.Item = BsCarousel.Item;
